import * as DataFormat from '../../../../Common/Scripts';

const APSAppointeeDataColumns = () => [
	{ dataField: 'rowId', text: 'Row ID', hidden: true, csvExport: false },
	{
		dataField: 'qualificationYear',
		text: 'Year',
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentType',
		text: 'Type',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markingTeamTitle',
		text: 'Marking Team Title',
		sort: true,
		headerClasses: 'th-title-td'
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'appointeeTitle',
		text: 'Title',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'initials',
		text: 'Initials',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'surName',
		text: 'Surname',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'niNumber',
		text: 'NI Number',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markerCode',
		text: 'Marker Code',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentStatus',
		text: 'Appointment Status',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'maxAllocation',
		text: 'Max Allocation',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'meetingAttendance',
		text: 'Meeting Attendance',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointeeId',
		text: 'Appointee ID',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentId',
		text: 'Appointment ID',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
    }
];

export default APSAppointeeDataColumns;
